// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"tmSWP","items":"NocXQ","item":"Dp8xI","link":"w8Cjf","text":"iVrz6","icon":"s5vKE"};